export var download = function (url, fileName) {
    fetch(url)
        .then(function (response) { return response.blob(); })
        .then(function (blob) {
        var _a;
        var blobUrl = window.URL.createObjectURL(blob);
        var fileNameExtension = (_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (fileNameExtension === 'pdf') {
            var pdfWindow = window.open();
            if (pdfWindow) {
                pdfWindow.location.href = blobUrl;
            }
            else {
                forceDownloadBlob(blobUrl, fileName);
            }
        }
        else {
            forceDownloadBlob(blobUrl, fileName);
        }
    });
};
var forceDownloadBlob = function (blobUrl, fileName) {
    var a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    a.click();
};
